import { render, staticRenderFns } from "./IncomeExpenditureDetails.vue?vue&type=template&id=6e21cf76&scoped=true"
import script from "./IncomeExpenditureDetails.vue?vue&type=script&lang=js"
export * from "./IncomeExpenditureDetails.vue?vue&type=script&lang=js"
import style0 from "./IncomeExpenditureDetails.vue?vue&type=style&index=0&id=6e21cf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21cf76",
  null
  
)

export default component.exports